export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;

  // iOS デバイスの検出 (iPhone, iPad, iPod)
  const ua = window.navigator.userAgent;
  const isIPad =
    /iPad/.test(ua) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  return /iPhone|iPod/.test(ua) || isIPad;
};

export const isStandalone = (): boolean => {
  if (typeof window === 'undefined') return false;

  const nav = window.navigator as Navigator & { standalone?: boolean };
  const isIOSStandalone = nav.standalone === true;
  const isGenericStandalone = window.matchMedia('(display-mode: standalone)').matches;

  return isIOSStandalone || isGenericStandalone;
};

const PWA_PROMPT_DISMISSED_KEY = 'novelflow_pwa_prompt_dismissed_time';
const PWA_PROMPT_COOLDOWN_MS = 3 * 24 * 60 * 60 * 1000;

/** PWA案内を自動表示する旧フローとの互換性を保つ判定関数。 */
export const shouldShowPwaPrompt = (): boolean => {
  if (!isIOS() || isStandalone() || typeof window === 'undefined') return false;

  try {
    if (typeof localStorage === 'undefined') return true;
    const dismissedAt = Number(localStorage.getItem(PWA_PROMPT_DISMISSED_KEY));
    return !Number.isFinite(dismissedAt) || Date.now() - dismissedAt > PWA_PROMPT_COOLDOWN_MS;
  } catch {
    return true;
  }
};

/** PWA案内を再表示しない期限の起点を記録する。 */
export const dismissPwaPrompt = (): void => {
  if (typeof window === 'undefined') return;

  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(PWA_PROMPT_DISMISSED_KEY, Date.now().toString());
  } catch {
    // Storage が使えない環境でも、呼び出し元の UI 操作は継続できる。
  }
};
